<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <div class="container">
        <div class="area_wrap">
          <div class="aw_blank">
            <span class="imgWrap"><img src="@/assets/images/thanq_logo.png"/></span>
            <p>회원님의 아이디는
              <b v-if="GET_ID !== ''">{{GET_ID}} </b>
              <b v-else>{{id}} </b>
              입니다.</p>
            <p>로그인 후 사용하시기 바랍니다.</p>
          </div>
        </div>
      </div>
      <div class="btnWrap visible half">
        <button type="button" class="black" @click.prevent="goFindPassword">비밀번호 찾기</button>
        <button type="button" @click.prevent="goLogin()">로그인</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '아이디 찾기',
        prevUrl: '/'
      },
      id: '',
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  methods: {
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapMutations([
      'SET_POPUP'
    ]),
    goFindPassword () {
      this.$router.push('/isTemp')
      sessionStorage.removeItem('findId')
    },
    goLogin () {
      this.$router.push('/login')
      sessionStorage.removeItem('findId')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  computed: {
    ...mapGetters([
      'GET_ID'
    ]),
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  created () {
    const findId = sessionStorage.getItem('findId')
    console.log('findId: ', findId)
    this.id = findId
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('idFind') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
